import React from 'react';

const PageStyles: React.FC = () => (
  <div>
    <header className="page-header container">
      <h1>Content pagina met de css styles</h1>
      <h3>H3 tekst. Dit is een intro tekst</h3>
    </header>
    <div className="page-content container">

        {/* Headings Section */}
        <section>
            {/* <h1>Heading Level 1</h1> */}
            <h2>Heading Level 2</h2>
            <h3>Heading Level 3</h3>
            <h4>Heading Level 4</h4>
            <h5>Heading Level 5</h5>
            <h6>Heading Level 6</h6>
        </section>

        {/* Paragraphs and Inline Text */}
        <section>
            <h2>Paragraphs and Text Elements</h2>
            <p>This is a standard paragraph. You can include <strong>bold</strong> text, <em>italicized</em> text, or even <u>underlined</u> text. You can also use <code>code</code> for inline code snippets.</p>
            <p><a href="/plannen">This is a link</a>. You can use CSS to style links differently for hover, active, and visited states.</p>
        </section>

        {/* Lists Section */}
        <section>
            <h2>Lists (Ordered and Unordered)</h2>

            {/* Unordered List */}
            <h3>Unordered List</h3>
            <ul>
                <li>First item</li>
                <li>Second item</li>
                <li>Third item</li>
                <li>
                    Nested List:
                    <ul>
                        <li>Sub-item 1</li>
                        <li>Sub-item 2</li>
                    </ul>
                </li>
            </ul>

            {/* Ordered List */}
            <h3>Ordered List</h3>
            <ol>
                <li>First item</li>
                <li>Second item</li>
                <li>Third item</li>
                <li>
                    Nested Ordered List:
                    <ol>
                        <li>Sub-item 1</li>
                        <li>Sub-item 2</li>
                    </ol>
                </li>
            </ol>
        </section>

        {/* Blockquote */}
        <section>
            <h2>Blockquote</h2>
            <blockquote>
                “This is a blockquote example. It's used to highlight quoted text in your design.”
            </blockquote>
        </section>

    </div>
  </div>
);

export default PageStyles;